export class DownloaderService {

  download(content: string, filename: string) {
    const url = window.URL.createObjectURL(new Blob([content]));
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.setAttribute("style", "display: none");
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
}
